<template>
  	<div class="animated fadeIn">
        <b-row>
		    <b-col cols="12">
				<b-card header-tag="header" footer-tag="footer">
			        <div slot="header">
						<i class="fa fa-map-pin"></i><strong> {{$trans['Zip_Codes']['cp4_verification']}}</strong> <!-- <small>dropdown support</small> -->
			        </div>
			        <div>
						<b-row>
							<b-col lg="6">
								<b-col sm="12" class="p-0">
                                    <b-form-group label="CP4" label-for="search-cp4">
                                        <b-form-input v-on:keyup.13.native="do_search" min="1" step="1" v-model="search.value" :class="(search.has_error) ? 'is-invalid' : ''" placeholder="xxxx" type="number" id="search-cp4" maxlength="4" class="text-capitalize"></b-form-input>
                                        <small v-if="search.has_error" class="text-danger">{{search.error}}</small>
                                    </b-form-group>
                                </b-col>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <!-- <h6>CP4 {{search.value}} encontra-se nos seguintes concelhos:</h6> -->
                                <loader v-if="loading" class="mr-3 ml-3"></loader>
                                <b-table striped hover :items="results" :fields="fields">
                                    <template #cell(county_name)="data">
                                        <!-- {{data}} -->
                                        <router-link :to="{name: 'Admin_Counties', params: {id: data.item.county_id, slug: data.value.toLowerCase()}}">{{data.value}}</router-link>
                                    </template>
                                </b-table>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="mt-3">
                                <router-link :to="{name: 'ZipCode'}">Procurar código postal</router-link>
                            </b-col>
                        </b-row>
                    </div>
                </b-card> 
            </b-col>
        </b-row>
	</div>
</template>
<script>

export default {
	data() {
		return {
			search: {
				value: '2765',
				has_error: false,
				error: this.$trans[this.$route.meta.trans_key]['cp4_404']
			},
            loading: false,
            fields: [
                {key: 'CP4'},
                {key: 'county_name'},
                {key: 'zip_codes_quantity'},
                {key: 'county_id', thClass: 'd-none', tdClass: 'd-none' },
            ],
            results: []
		}
	},
    methods: {
        do_search: function($event, find_or_fail=false) {
            const that = this;
            console.log({ name: that.$route.name, params: { search_param: that.$route.params.search_param }})
			that.get_req('cp4/' +this.search.value,
				function() { // before
                    that.search.has_error = false;
					that.loading = true;
                    that.$router.push({ name: that.$route.name, params: { search_param: that.search.value }})
	            },
				function(response) { // success
					that.results = response.body;
				},
				function(response) { // fail
                    that.search.has_error = true;
                    that.results = [];
					if(response.status == 404 && find_or_fail) {
						that.abort_404();
					}
				},
				function(response) {
					that.loading = false;
				}
			);
        }
    },
	computed: {
		
	},
    created() {
        if(this.$route.params.search_param == null) {
            this.$router.push({name: 'CP4', params: {search_param: 2765}});
        }
        else {
            this.search.value = this.$route.params.search_param;
        }
        this.do_search(null, true);
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>